export enum TrackingEvent {
  ReportListOpen = `Report list - open`,
  PresenceViewsLoaded = `Presence views loaded`,
  OverflowMenuClicked = `Overflow menu clicked`,
  OverflowMenuActionSelected = `Overflow menu action selected`,
  // TODO: stop tracking this in report header in favor of ReportEditor
  ReportSaved = `Report saved`,

  // Boards specific events
  LinkOnDashboard = `Link on Dashboard`,
  ReturnToBoard = `Return to Board`,
  // TODO: stop tracking these in report header in favor of ReportEditor
  StartSave = `Start Save`,
  StartReportDuplicate = `Start Report Duplicate`,
  StartReportRename = `Start Report Rename`,
  StartReportDelete = `Start Report Delete`,
  StartReportEditDescription = `Start Report Edit Description`,
}

export enum SaveTypeTrackingProperty {
  New = `New`,
  Duplicated = `Duplicated`,
  Existing = `Existing`,
  Renamed = `Renamed`,
}
